import React from 'react';
import './App.scss';

import { Routes, Route, Navigate } from 'react-router-dom';
import ls from "./services/localStorage";
import validateToken from "./services/validateToken";

import Clientes from './containers/Clientes/Clientes';
import Cursos from './containers/Cursos/Cursos';
import CrearCurso from './containers/CrearCurso/CrearCurso';
import EditarCurso from './containers/EditarCurso/EditarCurso';
import EditarCliente from './containers/EditarCliente/EditarCliente';
import Libros from './containers/Libros/Libros';
import Login from './containers/Login/Login';
import NotFound from './containers/NotFound/NotFound';
import Ventas from './containers/Ventas/Ventas';
import VentasCursos from './containers/VentasCursos/VentasCursos';
import GestorContenidos from './containers/GestorContenidos/GestorContenidos';
import { defaultMenuProps } from './constants/constants';
import { MenuProps } from './components/Menu/MenuTypes';
import Bundles from './containers/Bundles/Bundles';
import CrearBundle from './containers/CrearBundle/CrearBundle';
import EditarBundle from './containers/EditarBundle/EditarBundle';
import VentasBundles from './containers/VentasBundles/VentasBundles';
import Servicios from './containers/Servicios/Servicios';
import CrearServicio from './containers/CrearServicio/CrearServicio';
import EditarServicio from './containers/EditarServicio/EditarServicio';

const AuthWrapper = ({ children }: {children : React.ReactElement}): React.ReactElement => {
  const token = ls.get("token");

  if (validateToken.validate(token ? token : '')) {
    const user: ({ role: string } | null) = validateToken.getUser(token ? token : '')
    if(user && user.role === 'admin'){
      return children;
    }else{
      return <Navigate to="/login"></Navigate>;
    }
  } else {
    return <Navigate to="/login"></Navigate>;
  }
};

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path='/' element={<Navigate to='/clientes' />} />
        <Route path="/clientes" element={ <AuthWrapper><Clientes /></AuthWrapper> } />
        <Route path="/clientes/:clienteId" element={ <AuthWrapper><EditarCliente /></AuthWrapper> } />
        <Route path="/cursos" element={ <AuthWrapper><Cursos /></AuthWrapper> } />
        <Route path="/cursos/crear" element={ <AuthWrapper><CrearCurso /></AuthWrapper> } />
        <Route path="/cursos/:cursoId" element={ <AuthWrapper><EditarCurso/></AuthWrapper> } />
        <Route path="/libros" element={ <AuthWrapper><Libros /></AuthWrapper> } />
        <Route path="/login" element={ <Login /> } />
        <Route path="/ventas" element={ <AuthWrapper><Ventas /></AuthWrapper> } />
        <Route path="/ventas-cursos" element={ <AuthWrapper><VentasCursos /></AuthWrapper> } />
        <Route path="/gestor-contenidos" element={ <AuthWrapper><GestorContenidos /></AuthWrapper> } />
        <Route path="/bundles" element={ <AuthWrapper><Bundles /></AuthWrapper> } />
        <Route path="/bundles/crear" element={ <AuthWrapper><CrearBundle /></AuthWrapper> } />
        <Route path="/bundles/:bundleId" element={ <AuthWrapper><EditarBundle /></AuthWrapper> } />
        <Route path="/ventas-bundles" element={ <AuthWrapper><VentasBundles /></AuthWrapper> } />
        <Route path="/servicios" element={ <AuthWrapper><Servicios /></AuthWrapper> } />
        <Route path="/servicios/crear" element={ <AuthWrapper><CrearServicio /></AuthWrapper> } />
        <Route path="/servicios/:servicioId" element={ <AuthWrapper><EditarServicio /></AuthWrapper> } />
        <Route path='*' element={ <NotFound /> } />
      </Routes>
    </div>
  );
}

export default App;